import styled from "@emotion/styled";
import { Button } from "@mui/material";
import React, { useContext } from "react";
import { toast } from "react-toastify";
import { Context } from "../../context/app_context";
import { addBoxPrintQueue } from "../../services/box/box";

const PrintLabelsWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function PrintLabels({ boxId }: { boxId: number }) {
  const { setLoading } = useContext(Context);

  const onPrint = async () => {
    setLoading(true);
    const PrintQueueResponse = await addBoxPrintQueue(boxId);
    if (PrintQueueResponse.status === 200) {
      toast.success("Label sent to print queue");
    } else {
      toast.error("Can't send to print queue");
    }
    setLoading(false);
  };
  return (
    <>
      <PrintLabelsWrapper>
        <Button
          variant="contained"
          color="primary"
          sx={{
            fontSize: "1rem",
            borderRadius: 100,
            color: "white",
            paddingX: "2rem",
            gridArea: "1 / 1 / 3 / 3",
          }}
          onClick={onPrint}
        >
          Print Labels
        </Button>
      </PrintLabelsWrapper>
    </>
  );
}
